import React from 'react';

import StatusCircle from 'components/StatusCircle';

import { Status } from 'types/base';

export const getStatusBadge = (item: Status | string): React.ReactElement => {
  if (item === 'active') {
    return (
      <StatusCircle colorScheme="green" hasCircle={false}>
        Ativo
      </StatusCircle>
    );
  }

  if (item === 'inactive') {
    return (
      <StatusCircle colorScheme="gray" hasCircle={false}>
        Inativo
      </StatusCircle>
    );
  }

  if (item === 'editing') {
    return (
      <StatusCircle colorScheme="orange" hasCircle={false}>
        Em edição
      </StatusCircle>
    );
  }

  if (item === 'processing') {
    return (
      <StatusCircle colorScheme="blue" hasCircle={false}>
        Processando
      </StatusCircle>
    );
  }

  return (
    <StatusCircle colorScheme="gray" hasCircle={false}>
      Outro
    </StatusCircle>
  );
};
